import React from 'react'
// import CommonBanner
import CommonBanner from '../component/Common/CommonBanner'
// import AllFaqs
import AllFaqs from '../component/Faqs'
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags'

const Faqs = () => {
  return (
    <>
     <StaticSEOTags
        fallbackTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackKeywords="Polifly Travels"
        fallbackOgTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackOgDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackCanonicalUrl="https://poliflytravels.com/"
      />
      <CommonBanner heading="Faqs" pagination="Faqs"/>
      <AllFaqs/>
    </>
  )
}

export default Faqs